import { TxpOptionState } from '../store/schema/TxpOptionState';
import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../store/store';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import { getCalendarConfiguration } from 'owa-calendar-configuration';

export interface IsTxpOptionDirtyState {
    optionState: TxpOptionState;
}

/**
 * Returns if the Txp options page is in dirty state (user made changes to it)
 */
export default function isTxpOptionDirty(state?: IsTxpOptionDirtyState): boolean {
    let savedOptions: MailboxCalendarConfiguration = getCalendarConfiguration();
    let formOptions = getStore();

    if (!savedOptions) {
        return false;
    }

    let EventsFromEmailEnabled = getFallbackValueIfNull(
        formOptions.EventsFromEmailEnabled,
        savedOptions.EventsFromEmailEnabled
    );

    if (savedOptions.EventsFromEmailEnabled !== EventsFromEmailEnabled) {
        return true;
    }

    if (!EventsFromEmailEnabled) {
        // if savedOptions.EventsFromEmailEnabled == EventsFromEmailEnabled == false,
        // return not dirty since we don't have to check rest of the flags
        return false;
    }

    let CreateEventsFromEmailAsPrivate = getFallbackValueIfNull(
        formOptions.CreateEventsFromEmailAsPrivate,
        savedOptions.CreateEventsFromEmailAsPrivate
    );

    if (CreateEventsFromEmailAsPrivate !== savedOptions.CreateEventsFromEmailAsPrivate) {
        return true;
    }

    let isEventFlagDirty = false;

    // Validate if the event flags are changed
    Object.keys(formOptions.Events).map(eventType => {
        let eventEnabled = getFallbackValueIfNull(
            formOptions.Events[eventType],
            savedOptions[eventType]
        );

        if (eventEnabled !== savedOptions[eventType]) {
            isEventFlagDirty = true;
        }
    });

    return isEventFlagDirty;
}
